import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  fetchData,
  fetchFormData,
  getEncryptedRoute,
  hasSpecialCharacters,
  isOnlyNumber,
  isSpecificSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
  buildDropdownAudit,
} from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { FileUploader } from 'react-drag-drop-files'
import { AddHotelHeader } from './AddHotelHeader'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { Tr } from '../../../_metronic/i18n/Tr'

const AddHotelFinance: FC = () => {
  let t = Tr()
  const { menuId } = useMenuIdPermissions()
  const specialCharacterRegex = /^[a-zA-Z\u0400-\u04FF<>,-."'*()`’ ]*$/;

  const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''
  const [hotelDetails, setHotelDetails] = useState([])

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const navigate = useNavigate()
  const hotelId = sessionStorage.getItem('hotelId') || ''
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [ownerName, setOwnerName] = useState('')
  const [passportNumber, setPassportNumber] = useState('')
  const [JShShIR, setJShShIR] = useState('')
  const [businessName, setBusinessName] = useState('')
  const [businessSTIR, setBusinessSTIR] = useState('')
  const [mfo, setMfo] = useState('')
  const [bankName, setBankName] = useState('')
  const [branchName, setBranchName] = useState('')
  const [accountName, setAccountName] = useState('')
  const [accountNumber, setAccountNumber] = useState('')
  const [stir, setStir] = useState('')
  const [businessRegistration, setBusinessRegistration] = useState() as any
  const [businessIDProof, setBusinessIDProof] = useState() as any
  const [businessRgst, setBusinessRgst] = useState('')
  const [businessIDPrf, setBusinessIDPrf] = useState('')
  const [qqsList, setQqsList] = useState([]) as any
  const [mxikkodi, setMxikkodi] = useState('') as any
  const [mxikList, setMxikList] = useState([]) as any
  const [qqs, setQqs] = useState('')
  const [oIchovBirligi, setoIchovBirligi] = useState('') as any
  const [oIchovBirligiList, setOIchovBirligiList] = useState([]) as any

  // old dropdown states for audit labels
  const [oldQqs, setOldQqs] = useState<any>(null)
  const [oldMxikkodi, setOldMxikkodi] = useState<any>(null)
  const [oldOIchovBirligi, setOldOIchovBirligi] = useState<any>(null)


  // set error state
  const [error, setError] = useState([
    {
      ownerName: '',
      passportNumber: '',
      JShShIR: '',
      businessName: '',
      businessSTIR: '',
      qqs: '',
      mxikkodi: '',
      oIchovBirligi: '',
      mfo: '',
      bankName: '',
      branchName: '',
      accountName: '',
      accountNumber: '',
      ifscCode: '',
      stir: '',
      businessRegistration: '',
      businessIDProof: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]
    let firstErrorField = null

    if (ownerName.trim() == '' || ownerName.trim() == null || ownerName.trim() == undefined) {
      errorTmp[0].ownerName = t('Owner Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'ownerName'
    } else if (!isSpecificSpecialCharacters(ownerName.trim(), specialCharacterRegex)) {
      errorTmp[0].ownerName = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
      isValid = false
      if (!firstErrorField) firstErrorField = 'ownerName'
    }
    if (bankName.trim() == '' || bankName.trim() == null || bankName.trim() == undefined) {
      errorTmp[0].bankName = t('Bank Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'bankName'
    }

    if (branchName.trim() == '' || branchName.trim() == null || branchName.trim() == undefined) {
      errorTmp[0].branchName = t('Branch Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'branchName'
    }

    if ( accountName && !hasSpecialCharacters(accountName.trim())) {
      errorTmp[0].accountName = t('Special Characters Are Not Allowed')
      isValid = false
      if (!firstErrorField) firstErrorField = 'accountName'
    }
    if (
      accountNumber.trim() == '' ||
      accountNumber.trim() == null ||
      accountNumber.trim() == undefined
    ) {
      errorTmp[0].accountNumber = t('Account Number Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'accountNumber'
    } else if (!isOnlyNumber(accountNumber.trim())) {
      errorTmp[0].accountNumber = t('Only Number Is Allowed')
      isValid = false
      if (!firstErrorField) firstErrorField = 'accountNumber'
    }
    if (
      passportNumber.trim() == '' ||
      passportNumber.trim() == null ||
      passportNumber.trim() == undefined
    ) {
      errorTmp[0].passportNumber = t('Passport Number Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'passportNumber'
    } else if (!hasSpecialCharacters(passportNumber.trim())) {
      errorTmp[0].passportNumber = 'Special Characters Are Not Allowed'
      isValid = false
      if (!firstErrorField) firstErrorField = 'passportNumber'
    }
    if (JShShIR.trim() == '' || JShShIR.trim() == null || JShShIR.trim() == undefined) {
      errorTmp[0].JShShIR = t('JShShIR Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'JShShIR'
    }
    if (
      businessName.trim() == '' ||
      businessName.trim() == null ||
      businessName.trim() == undefined
    ) {
      errorTmp[0].businessName = t('Business Name Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'businessName'
    }
    if (
      businessSTIR.trim() == '' ||
      businessSTIR.trim() == null ||
      businessSTIR.trim() == undefined
    ) {
      errorTmp[0].businessSTIR = t('Business STIR Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'businessSTIR'
    }

    if (!qqs) {
      errorTmp[0].qqs = t('QQS Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'qqs'
    }
    if (!mxikkodi) {
      errorTmp[0].mxikkodi = t('MXIK kodi Is Required')
      isValid = false
      if (!firstErrorField) firstErrorField = 'mxikkodi'
    }
    if (!oIchovBirligi) {
      errorTmp[0].oIchovBirligi = t("O'Ichov Birligi Is Required")
      isValid = false
      if (!firstErrorField) firstErrorField = 'oIchovBirligi'
    }
    if (!businessRgst) {
      if (
        businessRegistration == undefined ||
        businessRegistration == null ||
        businessRegistration == undefined
      ) {
        errorTmp[0].businessRegistration = t('Business Registration Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'businessRegistration'
      }
    }
    if (!businessIDPrf) {
      if (businessIDProof == undefined || businessIDProof == null || businessIDProof == undefined) {
        errorTmp[0].businessIDProof = t('Business ID Proof Is Required')
        isValid = false
        if (!firstErrorField) firstErrorField = 'businessIDProof'
      }
    }

    setError(errorTmp)
    // If there was a validation error, scroll to the first error field
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
    return isValid
  }

  const fileTypes = ['JPEG', 'JPG', 'PNG', 'PDF']

  const handleBusinessRegistrationChange = (file: any) => {
    if (file) {
      if (!file.type.startsWith('image/') && file.type != 'application/pdf') {
        // Invalid file type
        // Handle error or display a message
        toasterrormsg('Invalid file type. Please upload only image or Pdf files.')
        setBusinessRegistration(undefined)

        return
      }
      // Handle business registration file change
      // For example:
      setBusinessRegistration(file)
      removeError('businessRegistration')
    } else {
    }
  }

  const handleBusinessIDProofChange = (file: any) => {
    if (file) {
      if (!file.type.startsWith('image/') && file.type != 'application/pdf') {
        // Invalid file type
        // Handle error or display a message
        toasterrormsg('Invalid file type. Please upload only image or Pdf files.')
        setBusinessIDProof(undefined)

        return
      }
      // Handle business registration file change
      // For example:
      setBusinessIDProof(file)
      removeError('businessIDProof')
    } else {
    }
  }
  const handleDivClick = (inputId: string) => {
    const inputElement = document.getElementById(inputId)
    if (inputElement) {
      inputElement.click()
    }
  }
  // add business details api call
  const addBusinessDetailsApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('hotelId', editHotelId)
      param.append('adminId', adminId)
      param.append('ownerName', ownerName)
      param.append('bankName', bankName)
      param.append('branchName', branchName)
      param.append('accountName', accountName)
      param.append('accountNumber', accountNumber)
      param.append('passportNumber', passportNumber)
      param.append('jShShIR', JShShIR)
      param.append('mfo', mfo)
      param.append('stir', stir)
      param.append('businessName', businessName)
      param.append('businessSTIR', businessSTIR)
      if (businessRegistration) {
        param.append('businessDocument', businessRegistration)
      }
      if (businessIDProof) {
        param.append('idProofDocument', businessIDProof)
      }
      param.append('qqs', qqs)
      param.append('mxikkodi', mxikkodi)
      param.append('oIchovBirligi', oIchovBirligi)
      param.append('labels', buildDropdownAudit({
        qqs: { old: oldQqs, new: qqsList.find((o: any) => o.value == qqs) || null },
        mxikkodi: { old: oldMxikkodi, new: mxikList.find((o: any) => o.value == mxikkodi) || { value: mxikkodi, label: mxikkodi } },
        oIchovBirligi: { old: oldOIchovBirligi, new: oIchovBirligiList.find((o: any) => o.value == oIchovBirligi) || { value: oIchovBirligi, label: oIchovBirligi } },
      }))
      var res = await fetchFormData('vendor/public/addHotelFinanceDetailV2', param)
      if (res.status == '200') {
        toastsuccessmsg('Finance Detail Added Successfully!')

        setTimeout(() => {
          navigate(getEncryptedRoute('../viewhotels/', { menuId: menuId }))

          setDisable(false)
          sessionStorage.removeItem('hotelId')
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
      }
    }
  }
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)
    if (response.status == '200') {
      setHotelDetails(response.data)
      var data = response.data[0]

      setOwnerName(data.ownerName)
      setBankName(data.bankName)
      setBranchName(data.branchName)
      setPassportNumber(data.passportNumber)
      setJShShIR(data.jShShIR)
      setMfo(data.mfo)
      setStir(data.stir)
      setBusinessName(data.businessName)
      setBusinessSTIR(data.businessSTIR)
      setAccountName(data.accountName)
      setAccountNumber(data.accountNumber)
      setBusinessRgst(data.businessDocument)
      setBusinessIDPrf(data.idProofDocument)
      setQqs(data.qqs)
      setMxikkodi(data.mxikkodi)
      setoIchovBirligi(data.oIchovBirligi)
      setOldQqs(qqsList.find((o: any) => o.value == data.qqs) || { value: data.qqs, label: data.qqs })
      setOldMxikkodi(mxikList.find((o: any) => o.value == data.mxikkodi) || { value: data.mxikkodi, label: data.mxikkodi })
      setOldOIchovBirligi(oIchovBirligiList.find((o: any) => o.value == data.oIchovBirligi) || { value: data.oIchovBirligi, label: data.oIchovBirligi })
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
  }, [])

  const qqsListApiCall = async () => {
    var response: any = await fetchData('vendor/public/qqsList', {})
    if (response.status == '200') {

      const filterData = response.data.map((item: any) => ({ label: item.name, value: item.qqsId }))
      setQqsList(filterData)
    } else {
      toasterrormsg(response.message)
    }
  }
  const mxikkodiListApiCall = async () => {
    var response: any = await fetchData('vendor/public/mxikkodiList', {})
    if (response.status == '200') {
      const filterData = response.data.map((item: any) => ({ label: item.name, value: item.name }))
      setMxikList(filterData)
    } else {
      toasterrormsg(response.message)
    }
  }
  const oIchovBirligiListApiCall = async (mxikkodi: any) => {
    const param = {
      mxikkodiName: mxikkodi,
    }
    var response: any = await fetchData('vendor/public/oIchovBirligiList', param)
    if (response.status == '200') {
      const filterData = response.data.map((item: any) => ({ label: item.name, value: item.name }))
      setOIchovBirligiList(filterData)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    qqsListApiCall()
    mxikkodiListApiCall()
  }, [])
  useEffect(() => {
    if (mxikkodi) {
      oIchovBirligiListApiCall(mxikkodi)
    }
  }, [mxikkodi])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editHotelId != '' ? t('Edit Finance & Legal Information') : t('Add Finance & Legal Information')}
      </PageTitle>
      <AddHotelHeader hotelId={editHotelId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t("Finance & Legal Information")}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {hotelDetails.length != 0 ? (
                            <>
                              {hotelDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['roomAndSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t("Completion")}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t("Completion")}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-12 my-3'>
                            <label className='fs-3 form-label fw-bold'>{t("Owner Details:")}</label>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Property Owner Name")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='ownerName'
                              id='ownerName'
                              className='form-control mb-2'
                              placeholder={t('Owner Name')}
                              value={ownerName}
                              onChange={(e) => {
                                setOwnerName(e.target.value)
                                removeError('ownerName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].ownerName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("ID/Passport Number")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='passportNumber'
                              id='passportNumber'
                              className='form-control mb-2'
                              placeholder={t('ID/Passport Number')}
                              value={passportNumber}
                              onChange={(e) => {
                                setPassportNumber(e.target.value)
                                removeError('passportNumber')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].passportNumber}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("JShShIR (ПИНФЛ)")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='JShShIR'
                              id='JShShIR'
                              className='form-control mb-2'
                              placeholder={t('JShShIR')}
                              value={JShShIR}
                              onChange={(e) => {
                                setJShShIR(e.target.value)
                                removeError('JShShIR')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].JShShIR}</div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-12 my-3'>
                            <label className='fs-3 form-label fw-bold'>{t("Business Details:")}</label>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Business Name")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='businessName'
                              id='businessName'
                              className='form-control mb-2'
                              placeholder={t('Business Name')}
                              value={businessName}
                              onChange={(e) => {
                                setBusinessName(e.target.value)
                                removeError('businessName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].businessName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Business STIR")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='businessSTIR'
                              id='businessSTIR'
                              className='form-control mb-2'
                              placeholder={t('Business STIR')}
                              value={businessSTIR}
                              onChange={(e) => {
                                setBusinessSTIR(e.target.value)
                                removeError('businessSTIR')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].businessSTIR}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='form-label fs-4 required'>{t("QQS")}</label>
                            <Select
                              name='qqs'
                              id='qqs'
                              placeholder={t('Select')}
                              isSearchable={true}
                              options={qqsList}
                              value={qqsList.find((option: any) => option.value == qqs) || ''}
                              onChange={(option: any) => {
                                setQqs(option.value)
                                removeError('qqs')
                              }}
                            />
                            <div className='text-danger fw-bold'>{error[0].qqs}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='form-label fs-4 required'>{t("MXIK kodi")}</label>
                            <CreatableSelect
                              name='mxikkodi'
                              id='mxikkodi'
                              placeholder={t('MXIK kodini kiriting')}
                              isSearchable={true}
                              options={mxikList}
                              value={
                                mxikList.find((option: any) => option.value == mxikkodi) || null
                              }
                              onChange={(option: any) => {
                                setMxikkodi(option ? option.value : '')
                                removeError('mxikkodi')
                              }}
                              onCreateOption={(option : string) => {
                                const newOption = { value: option, label: option }
                                setMxikList((prev: any) => [...prev, newOption]) // Add new option to list
                                setMxikkodi(option) // Set the new value
                                removeError('mxikkodi')
                              }}
                              isClearable
                            />
                            <div className='text-danger fw-bold'>{error[0].mxikkodi}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            <label className='form-label fs-4 required'>{t("O'Ichov Birligi")}</label>
                            <CreatableSelect
                              name='oIchovBirligi'
                              id='oIchovBirligi'
                              placeholder={t("O'Ichov Birligi kiriting")}
                              isSearchable={true}
                              options={oIchovBirligiList}
                              value={
                                oIchovBirligiList.find(
                                  (option: any) => option.value == oIchovBirligi
                                ) || null
                              }
                              onChange={(option: any) => {
                                setoIchovBirligi(option ? option.value : '')
                                removeError('oIchovBirligi')
                              }}
                              onCreateOption={(option : string) => {
                                const newOption = { value: option, label: option }
                                setOIchovBirligiList((prev: any) => [...prev, newOption]) // Add new option to list
                                setoIchovBirligi(option) // Set the new value
                                removeError('oIchovBirligi')
                              }}
                              isClearable
                            />
                            <div className='text-danger fw-bold'>{error[0].oIchovBirligi}</div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-lg-12 my-3'>
                            <label className='fs-3 form-label fw-bold'>{t("Bank Details:")}</label>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Bank Name")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='bankName'
                              id='bankName'
                              className='form-control mb-2'
                              placeholder={t('Bank Name')}
                              value={bankName}
                              onChange={(e) => {
                                setBankName(e.target.value)
                                removeError('bankName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].bankName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Branch Name")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='branchName'
                              id='branchName'
                              className='form-control mb-2'
                              placeholder={t('Branch Name')}
                              value={branchName}
                              onChange={(e) => {
                                setBranchName(e.target.value)
                                removeError('branchName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].branchName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className=' fs-4 form-label'>{t("Account Name")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='accountName'
                              id='accountName'
                              className='form-control mb-2'
                              placeholder={t('Account Name')}
                              value={accountName}
                              onChange={(e) => {
                                setAccountName(e.target.value)
                                removeError('accountName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].accountName}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("Account Number")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='accountNumber'
                              id='accountNumber'
                              className='form-control mb-2'
                              placeholder={t('Account Number')}
                              value={accountNumber}
                              onChange={(e) => {
                                setAccountNumber(e.target.value)
                                removeError('accountNumber')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].accountNumber}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t("MFO")}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='mfo'
                              id='mfo'
                              className='form-control mb-2'
                              placeholder={t('MFO')}
                              value={mfo}
                              onChange={(e) => {
                                setMfo(e.target.value)
                                removeError('mfo')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].mfo}</div>
                          </div>
                          {/* <div className='col-lg-4 my-3'>
                              <label className='required fs-4 form-label'>STIR (ИНН)</label>
                              <input
                                type='text'
                                name='stir'
                                id='stir'
                                className='form-control mb-2'
                                placeholder='STIR'
                                value={stir}
                                onChange={(e) => {
                                  setStir(e.target.value)
                                  removeError('stir')
                                }}
                              />
                              <div className='text-danger fw-bold'>{error[0].stir}</div>
                            </div> */}
                        </div>
                        {/* <!--end::Input group--> */}
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-6'>
                            <div className='mt-5' id='businessRegistration'>
                              <FileUploader
                                multiple={false}
                                handleChange={handleBusinessRegistrationChange}
                                name='businessRegistration'
                                types={fileTypes}
                                classes='w-100'
                              >
                                <div
                                  className='dropzone border-success bg-light-success dz-clickable'
                                  id='kt_ecommerce_add_business_certificate'
                                  onClick={() => handleDivClick('businessRegistration')}
                                >
                                  <div className='dz-message needsclick'>
                                    {/* <!--begin::Icon--> */}
                                    <i className='ki-outline ki-file-up text-success fs-3x'></i>
                                    {/* <!--end::Icon--> */}
                                    {/* <!--begin::Info--> */}
                                    <div className='ms-4'>
                                      <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                                        {t("Upload Business Registration")}
                                      </h3>
                                      <span className='fs-7 fw-semibold text-gray-500'>
                                        {t("Drag & Drop or choose files from computer")}
                                      </span>
                                    </div>
                                    {/* <!--end::Info--> */}
                                  </div>
                                </div>
                              </FileUploader>
                              {/* <!--begin::Message--> */}
                            </div>
                            <div className='text-danger fw-bold'>
                              {error[0].businessRegistration}
                            </div>
                            <div className='row mt-3'>
                              {businessRegistration ? (
                                <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                                  {businessRegistration &&
                                    businessRegistration.type.startsWith('image/') ? (
                                    <div
                                      className='shadow-sm rounded-4'
                                      style={{
                                        maxWidth: 'fit-content',
                                        width: '300px',
                                        height: '200px',
                                      }}
                                    >
                                      <a
                                        rel='noreferrer'
                                        href={URL.createObjectURL(businessRegistration)}
                                        target='_blank'
                                      >
                                        <img
                                          alt='images'
                                          className='p-2 rounded-4'
                                          src={URL.createObjectURL(businessRegistration)}
                                          width='100%'
                                          style={{ width: '300px', height: '200px' }}
                                        />
                                      </a>
                                    </div>
                                  ) : (
                                    <div className='card h-200px shadow-sm rounded-4 w-300px'>
                                      <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                                        <a
                                          rel='noreferrer'
                                          href={URL.createObjectURL(businessRegistration)}
                                          target='_blank'
                                          className='text-gray-800 text-hover-primary d-flex flex-column'
                                        >
                                          <div className='symbol symbol-75px mb-6'>
                                            <img
                                              src={toAbsoluteUrl('/media/otherSVG/pdf.svg')}
                                              alt='pdf'
                                            />
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <>
                                  {businessRgst ? (
                                    <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                                      {businessRgst && businessRgst.endsWith('.pdf') ? (
                                        <div className='card h-200px shadow-sm rounded-4 w-300px'>
                                          <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                                            <a
                                              rel='noreferrer'
                                              href={businessRgst}
                                              target='_blank'
                                              className='text-gray-800 text-hover-primary d-flex flex-column'
                                            >
                                              <div className='symbol symbol-75px mb-6'>
                                                <img
                                                  src={toAbsoluteUrl('/media/otherSVG/pdf.svg')}
                                                  alt='pdf'
                                                />
                                              </div>
                                            </a>
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className='shadow-sm rounded-4'
                                          style={{
                                            maxWidth: 'fit-content',
                                            width: '300px',
                                            height: '200px',
                                          }}
                                        >
                                          <a rel='noreferrer' href={businessRgst} target='_blank'>
                                            <img
                                              alt='images'
                                              className='p-2 rounded-4'
                                              src={businessRgst}
                                              width='100%'
                                              style={{ width: '300px', height: '200px' }}
                                            />
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <div className='col-lg-6'>
                            <div className='mt-5' id='businessIDProof'>
                              <FileUploader
                                multiple={false}
                                handleChange={handleBusinessIDProofChange}
                                name='businessIDProof'
                                types={fileTypes}
                                classes='w-100'
                              >
                                <div
                                  className='dropzone border-success bg-light-success dz-clickable'
                                  id='kt_ecommerce_add_business_certificate'
                                  onClick={() => handleDivClick('businessIDProof')}
                                >
                                  <div className='dz-message needsclick'>
                                    {/* <!--begin::Icon--> */}
                                    <i className='ki-outline ki-file-up text-success fs-3x'></i>
                                    {/* <!--end::Icon--> */}
                                    {/* <!--begin::Info--> */}
                                    <div className='ms-4'>
                                      <h3 className='fs-5 fw-bold text-gray-900 mb-1'>
                                        {t("Upload ID Proof")}
                                      </h3>
                                      <span className='fs-7 fw-semibold text-gray-500'>
                                        {t("Drag & Drop or choose files from computer")}
                                      </span>
                                    </div>
                                    {/* <!--end::Info--> */}
                                  </div>
                                </div>
                              </FileUploader>
                              {/* <!--begin::Message--> */}
                            </div>
                            <div className='text-danger fw-bold'>{error[0].businessIDProof}</div>
                            <div className='row mt-3'>
                              {businessIDProof ? (
                                <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                                  {businessIDProof && businessIDProof.type.startsWith('image/') ? (
                                    <div
                                      className='shadow-sm rounded-4'
                                      style={{
                                        maxWidth: 'fit-content',
                                        width: '300px',
                                        height: '200px',
                                      }}
                                    >
                                      <a
                                        rel='noreferrer'
                                        href={URL.createObjectURL(businessIDProof)}
                                        target='_blank'
                                      >
                                        <img
                                          alt='images'
                                          className='p-2 rounded-4'
                                          src={URL.createObjectURL(businessIDProof)}
                                          width='100%'
                                          style={{ width: '300px', height: '200px' }}
                                        />
                                      </a>
                                    </div>
                                  ) : (
                                    <div className='card h-200px shadow-sm rounded-4 w-300px'>
                                      <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                                        <a
                                          rel='noreferrer'
                                          href={URL.createObjectURL(businessIDProof)}
                                          target='_blank'
                                          className='text-gray-800 text-hover-primary d-flex flex-column'
                                        >
                                          <div className='symbol symbol-75px mb-6'>
                                            <img
                                              src={toAbsoluteUrl('/media/otherSVG/pdf.svg')}
                                              alt='pdf'
                                            />
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <>
                                  {businessIDPrf ? (
                                    <div className='col-lg-12 col-3 d-flex flex-column mb-5'>
                                      {businessIDPrf && businessIDPrf.endsWith('.pdf') ? (
                                        <div className='card h-200px shadow-sm rounded-4 w-300px'>
                                          <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                                            <a
                                              rel='noreferrer'
                                              href={businessIDPrf}
                                              target='_blank'
                                              className='text-gray-800 text-hover-primary d-flex flex-column'
                                            >
                                              <div className='symbol symbol-75px mb-6'>
                                                <img
                                                  src={toAbsoluteUrl('/media/otherSVG/pdf.svg')}
                                                  alt='pdf'
                                                />
                                              </div>
                                            </a>
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className='shadow-sm rounded-4'
                                          style={{
                                            maxWidth: 'fit-content',
                                            width: '300px',
                                            height: '200px',
                                          }}
                                        >
                                          <a rel='noreferrer' href={businessIDPrf} target='_blank'>
                                            <img
                                              alt='images'
                                              className='p-2 rounded-4'
                                              src={businessIDPrf}
                                              width='100%'
                                              style={{ width: '300px', height: '200px' }}
                                            />
                                          </a>
                                        </div>
                                      )}
                                    </div>
                                  ) : (
                                    ''
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addBusinessDetailsApi}
                >
                  <span className='indicator-label'>{t("Submit")}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddHotelFinance }
